package com.essntl.uikit.components.button.primary

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.utils.EsConstants

@Composable
fun EsLargePrimaryDoubleButton(
    firstTextButton: String,
    secondTextButton: String,
    firstButtonOnClick: () -> Unit,
    secondButtonOnClick: () -> Unit,
    firstButtonPrefixIconRes: String? = null,
    secondButtonPrefixIconRes: String? = null,
    firstSuffixIconRes: String? = null,
    secondSuffixIconRes: String? = null,
    firstButtonShape: Shape = RoundedCornerShape(EsConstants.ButtonBorderRadius),
    secondButtonShape: Shape = RoundedCornerShape(EsConstants.ButtonBorderRadius),
    firstButtonEnabled: Boolean = true,
    secondButtonEnabled: Boolean = true,
    firstButtonLoading: Boolean = false,
    secondButtonLoading: Boolean = false,
    modifier: Modifier = Modifier,
) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(0.dp),
        modifier = modifier,
    ) {
        EsLargePrimaryButton(
            text = firstTextButton,
            shape = firstButtonShape,
            onClick = firstButtonOnClick,
            prefixIconRes = firstButtonPrefixIconRes,
            suffixIconRes = firstSuffixIconRes,
            enabled = firstButtonEnabled,
            loading = firstButtonLoading,
            withFocusBorder = false,
        )

        EsLargePrimaryButton(
            text = secondTextButton,
            shape = secondButtonShape,
            onClick = secondButtonOnClick,
            prefixIconRes = secondButtonPrefixIconRes,
            suffixIconRes = secondSuffixIconRes,
            enabled = secondButtonEnabled,
            loading = secondButtonLoading,
            withFocusBorder = false,
        )
    }
}